import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isTaskStatusEditionRequestFailure() {
      return getState().request.isFailure;
    },
    isTaskStatusEditionRequestPending() {
      return getState().request.isPending;
    },
    isTaskStatusEditionRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
